// extracted by mini-css-extract-plugin
export var dark = "roundedText-module--dark--5650a";
export var description = "roundedText-module--description--fb5ba";
export var error = "roundedText-module--error--ce98a";
export var input = "roundedText-module--input--6e4a8";
export var label = "roundedText-module--label--00b19";
export var light = "roundedText-module--light--00dfd";